import React from 'react';
//import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { store } from './store/Store';
import App from './App';
import './data';
import { initSentry, SentryErrorBoundary } from './services/sentry';
import { bootstrapImpersonation } from './utils/impersonationBootstrap';
import { bootstrapVersaoGuard } from './utils/versaoGuard';

// Inicializa Sentry o mais cedo possivel para capturar erros do bootstrap.
// No-op se REACT_APP_SENTRY_DSN nao estiver definida.
initSentry();

// Detecta JWT impersonado vindo do Phada Admin via URL hash
// (#imp_token=...). Se detectar, salva no localStorage e remove o hash
// antes do React montar - sessao ja inicia como impersonada.
bootstrapImpersonation();

// Gate de versao: devolve para o v1 quem nao esta mais em versao = 2.
// Antes de montar o React para nao renderizar a UI errada e so depois sair
// dela. Quando redireciona, nada abaixo importa — a pagina esta trocando.
bootstrapVersaoGuard();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <SentryErrorBoundary
        fallback={({ error, resetError }) => (
          <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
            <h2>Algo deu errado</h2>
            <p>O erro foi reportado. Voce pode tentar continuar:</p>
            <button type="button" onClick={resetError} style={{ padding: '8px 16px' }}>
              Tentar novamente
            </button>
            {process.env.NODE_ENV !== 'production' && (
              <pre style={{ marginTop: 16, color: '#c00', whiteSpace: 'pre-wrap' }}>
                {error?.toString()}
              </pre>
            )}
          </div>
        )}
      >
        {/* basename vem do homepage do package.json via PUBLIC_URL: o v2 e
            servido em /v2, e sem isso o roteador nao casaria nenhuma rota. */}
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <App />
        </BrowserRouter>
      </SentryErrorBoundary>
    </React.StrictMode>
  </Provider>,
);


/*ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,

  document.getElementById('root'),
); */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
